module.exports = __webpack_public_path__ + "img/mbh-info-shape.82e7def0.svg";